import { useRouter } from 'next/router'

import { createParam } from 'solito'

import usePagination from 'app/hooks/usePagination'
import { useGetBlogArticles } from 'app/services/Query/blog/blog.query'
import { getSearchByTagQueryParams } from 'app/utils/helpers/blog.helpers'

const placeholderArticles = [
  { id: '1' },
  { id: '2' },
  { id: '3' }
] as BlogArticleModel[]

const { useParam } = createParam()

export const useArticlesByTagView = () => {
  const router = useRouter()
  const [tag = ''] = useParam('slug')

  const pathname = `/blog/search-by/${tag}`
  const { setPage, page } = usePagination({ pathname, disableScroll: true })

  const params = getSearchByTagQueryParams({ tag, p: page })

  const {
    data: blog,
    isFetching,
    isPlaceholderData
  } = useGetBlogArticles({
    params,
    options: {
      enabled: false,
      placeholderData: {
        articles: placeholderArticles,
        pagy: {},
        articles_count: placeholderArticles.length
      }
    }
  })

  const { articles, pagy } = blog || {}

  const showPagination = Number(pagy?.pages) > 1
  const hasArticles = !!articles && articles.length > 0
  const isEmptyBlog = !isFetching && !hasArticles
  const isPageLoading = router.isFallback || isPlaceholderData

  return {
    articles,
    hasArticles,
    isEmptyBlog,
    isPageLoading,
    pagy,
    page,
    showPagination,
    setPage,
    tag
  }
}
